import { useEffect } from 'react';

interface SEOMetaProps {
  title: string;
  description?: string;
  keywords?: string;
  canonical?: string;
}

export default function SEOMeta({ title, description, keywords, canonical }: SEOMetaProps) {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = title;

    let descMeta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    const originalDesc = descMeta?.content;
    if (description) {
      if (!descMeta) {
        descMeta = document.createElement('meta');
        descMeta.name = 'description';
        document.head.appendChild(descMeta);
      }
      descMeta.content = description;
    }

    let kwMeta = document.querySelector('meta[name="keywords"]') as HTMLMetaElement | null;
    const originalKw = kwMeta?.content;
    if (keywords) {
      if (!kwMeta) {
        kwMeta = document.createElement('meta');
        kwMeta.name = 'keywords';
        document.head.appendChild(kwMeta);
      }
      kwMeta.content = keywords;
    }

    let ogTitle = document.querySelector('meta[property="og:title"]') as HTMLMetaElement | null;
    if (ogTitle) ogTitle.content = title;

    let ogDesc = document.querySelector('meta[property="og:description"]') as HTMLMetaElement | null;
    if (ogDesc && description) ogDesc.content = description;

    let twitterTitle = document.querySelector('meta[name="twitter:title"]') as HTMLMetaElement | null;
    if (twitterTitle) twitterTitle.content = title;

    let twitterDesc = document.querySelector('meta[name="twitter:description"]') as HTMLMetaElement | null;
    if (twitterDesc && description) twitterDesc.content = description;

    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    const originalCanonical = canonicalLink?.href;
    if (canonical) {
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.rel = 'canonical';
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.href = canonical;
    }

    return () => {
      document.title = originalTitle;
      if (descMeta && originalDesc !== undefined) descMeta.content = originalDesc;
      if (kwMeta && originalKw !== undefined) kwMeta.content = originalKw;
      if (canonicalLink && originalCanonical !== undefined) canonicalLink.href = originalCanonical;
    };
  }, [title, description, keywords, canonical]);

  return null;
}